import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
		width: '95%',
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	chip: {
		margin: theme.spacing.unit / 4,
	},
	noLabel: {
		marginTop: theme.spacing.unit * 3,
	},
	permissionSelect: {
		borderRadius: '4px',
		padding: theme.spacing.unit,
		color: '#666',
	},
	peopleText: {
		marginBottom: theme.spacing.unit / 4,
	},
	searchRoot: {
		padding: theme.spacing.unit / 4,
		marginTop: theme.spacing.unit,
		marginBottom: theme.spacing.unit,
		border: '1px solid #DFDFDF',
		width: '100%'
	},
	sharedWithText: {
		marginRight: theme.spacing.unit / 2,
		fontWeight: 600,
		fontSize: '1.2rem',
		lineHeight: '2.5'
	},
	userChipRoot: {
		padding: theme.spacing.unit,
		marginLeft: theme.spacing.unit / 4,
		marginRight: theme.spacing.unit / 4,
		marginBottom: theme.spacing.unit / 4,
		background: '#F8F8F8',
		border: '1px solid #E5E5E5',
		borderRadius: '4px',
	},
	userChipLabel: {
		lineHeight: '16px',
		color: '#2196F3',
	},
	userChipIcon: {
		color: '#FF4646'
	},
	suggestContainer: {
		position: 'relative',
	},
	suggestList: {
		position: 'absolute',
		top: '34px',
		left: '0',
		background: '#fff',
		boxShadow: '0px 0px 2px #ccc',
		padding: 0,
		zIndex: 10,
		listStyleType: 'none',
		marginTop: 0,
		width: '100%',
	},
	suggestItem: {
		padding: theme.spacing.unit,
		paddingBottom: theme.spacing.unit + 4,
		cursor: 'pointer',
		zIndex: 11,
		'&::after': {
			content: '',
			display: 'table',
			clear: 'both',
		},
		gapRgt:{
			marginRight:'30px',
		}
	}
});